import { api } from "../../../infra/api";
import { URLS } from "../../../infra/URLS";
import Swal from "sweetalert2";
import { queryClient } from "../../..";

export default async function putUser(
  userId: number,
  usuarioAtual: any,
  onSuccess: () => void
  ) {
  return await api
    .put(`${URLS.USER_API}/${userId}`, {
      UsuarioId: usuarioAtual.UsuarioId,
      Login: usuarioAtual.Login,
      Senha: usuarioAtual.Senha,
      Ativo: usuarioAtual.Ativo === true ? 1 : 0,
      MudarSenha: usuarioAtual.Ativo === true ? 1 : 0,
    })
    .then((response) => {
      console.log(response);
      onSuccess();
      Swal.fire({
        title: "Usuário Editado",
        text: "O usuário foi editado com sucesso!",
        icon: "success",
        position: "center",
        confirmButtonText: "OK",
        confirmButtonColor: "#349946",
        allowOutsideClick: false,
      }).then((response) => {
        if (response.isConfirmed) {
          queryClient.invalidateQueries();
        }
      });
    })
    .catch((err) => {
      console.log(err);
      if (err.response.status === 500) {
        Swal.fire({
          title: `Erro de status ${err.response.status}`,
          text: `Ocorreu um erro interno ao cadastrar o usuário. Por favor, entre em contato com um administrador do sistema.`,
          icon: "error",
          position: "center",
          confirmButtonText: "OK",
          confirmButtonColor: "#F27474",
          allowOutsideClick: false,
        });
      }
      if (err.response.status === 400) {
        Swal.fire({
          title: "Erro ao cadastrar o produto",
          text: err.response.data.message,
          icon: "error",
          position: "center",
          confirmButtonText: "OK",
          confirmButtonColor: "#F27474",
          allowOutsideClick: false,
        });
      }
    });
}
